import React, { useCallback, useEffect, useState } from 'react'
import CustomerAgentApi from '../../../../api/customer-agent/customer-agent.api';
import {
    List,
    ListItem,
    ListItemText,
    Typography,
    Paper,
    Box,
    Snackbar,
    Alert,
    // Button,
    IconButton
} from "@mui/material";
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useHistory } from 'react-router-dom';


type Props = {
    id_customer: number;
}

const ModalAgent: React.FC<Props> = ({ id_customer }: Props) => {
    const history = useHistory();
    // อาจจะต้องมีเส้นใหม่ เหมือน query ไปหา token ตามตัวเองแล้ว where customer ของตัวเอง เดา เพราะ 500 แต่ login ดูของตัวเองได้
    const [open, setOpen] = useState<boolean>(false);
    const [data, set_data] = useState<any[]>([]);

    const handleGetData = useCallback(async () => {
        const res = await CustomerAgentApi.listCustomerNew({
            page: 1,
            limit: 100000,
            sortBy: "createDate",
            sortType: "DESC",
            customerId: id_customer
        });
        if(res.status < 300){
            const response = (res.data as any)?.data;
            set_data(response?.items || []);
        }else{
            set_data([]);
        }
    }, [])

    useEffect(() => {
        handleGetData();
    }, [])


    //     const handleCopy = async (item: { customer_fullname: string, customerId_agent: string, customer_agent_mobilePhone: string }) => {
    //         const text = `
    // ชื่อ: ${item.customer_fullname}
    // เบอร์โทรศัพท์: ${item.customer_agent_mobilePhone}
    //     `;
    //         try {
    //             await navigator.clipboard.writeText(text);
    //             setOpen(true);
    //         } catch (err) {
    //             console.error("Copy failed", err);
    //         }
    //     };

    if(data?.length === 0) return <Typography>ไม่พบข้อมูล...</Typography>
    return (
        <>
            <Paper elevation={1} sx={{ p: 2, my: 5 }}>
                <List>
                    {data?.map((item: any, index) => (
                        <ListItem
                            key={item.id_customer_agent}
                            divider={data?.length - 1 !== index}
                            sx={{ py: 1 }}
                        >
                            <ListItemText
                                primary={item.customer_fullname}
                                secondary={
                                    <Box display={"flex"} justifyContent={{ xs: "flex-start", lg: "space-between" }}>
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">
                                                เบอร์โทร : {item.customer_agent_mobilePhone}
                                            </Typography>
                                        </Box>
                                        <Box display={"flex"} gap={1}>
                                            <IconButton sx={{ maxWidth: "fit-content", alignSelf: "end" }} onClick={() => {
                                                history.push(`/agent-profile/${item?.id_customer_agent}`, {
                                                    isAdmin: true
                                                })
                                            }}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                            {/* <IconButton sx={{ maxWidth: "fit-content", alignSelf: "end" }} onClick={() => handleCopy({ ...item })}>
                                                <ContentCopyIcon />
                                            </IconButton> */}
                                        </Box>

                                    </Box>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>
            {/* Snackbar แจ้งเตือน */}
            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert severity="success" variant="filled">
                    คัดลอกข้อมูลเรียบร้อย
                </Alert>
            </Snackbar>
        </>
    )
}

export default ModalAgent